module.exports = __webpack_public_path__ + "static/media/companyStamp.74649b56.JPG";